/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";
// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";
import MDAlert from "components/MDAlert";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup'
// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import { useSearchParams, Link } from "react-router-dom";
import { AuthAPI } from "api/AuthAPI";
import CircularProgress from "@mui/material/CircularProgress";

// Images
import bgImage from "assets/images/bg-reset-cover.jpeg";

function Cover() {

  const formSchema = yup.object().shape({
    password: yup.string().required('El campo es requerido').min(8, 'La contraseña debe tener al menos 8 caracteres'),
    password_confirmation: yup.string().required('El campo es requerido').oneOf([yup.ref('password')], 'La contraseña no coincide'),
  })

  let [searchParams, setSearchParams] = useSearchParams();
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const { handleSubmit, register, formState: { errors, isSubmitting }, } = useForm({ resolver: yupResolver(formSchema), });

  const alertComponent = (
    <MDAlert color={alertColor}>
      <MDTypography variant="body2" color="white">
        {alertContent}
      </MDTypography>
    </MDAlert>
  );

  const onSubmit = (data) => {
    data.email = searchParams.get("email");
    data.token = searchParams.get("token");
    return AuthAPI.reset(data)
      .then(response => {
        setAlertContent(response.message);
        setAlertColor('success');
        setAlert(true)
      }).catch(error => {
        setAlertContent(error.response.data.message);
        setAlertColor('error');
        setAlert(true)
      });

  }

  return (
    <CoverLayout>
      <MDBox mb={4} px={2}>
        {alert ? alertComponent : <></>}
      </MDBox>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Confirmar Contraseña
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Ingresa tu nueva contraseña
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
            <MDBox mb={2}>
              <MDInput type="password" label="Contraseña" name="password" {...register("password")} fullWidth />
              {errors.password && <MDTypography variant="button" color="error">{errors.password?.message}</MDTypography>}
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" label="Confirmar Contraseña" name="password_confirmation " {...register("password_confirmation")} fullWidth />
              {errors.password_confirmation && <MDTypography variant="button" color="error">{errors.password_confirmation?.message}</MDTypography>}
            </MDBox>
            <MDBox mt={6} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={isSubmitting}>
                {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Restaurar'}
              </MDButton>
            </MDBox>
            <MDBox mt={1} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                <MDTypography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Iniciar Sesión
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>

      </Card>
    </CoverLayout>
  );
}

export default Cover;